// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-components-ImportModal-ConfirmImportModal-__ConfirmImportModal___1moI-","header-delete":"app-components-ImportModal-ConfirmImportModal-__ConfirmImportModal___3BwLH","title-modal":"app-components-ImportModal-ConfirmImportModal-__ConfirmImportModal___3EHXF"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ImportModal/ConfirmImportModal/ConfirmImportModal.css
// module id = 1969
// module chunks = 0